<script>
    export default {
        props: {
            seeDirectoryActions: Boolean,
        },
        data() {
            return {
                loading: true,
                tree: [],
                uri: URI(window.location.href),
                selected: [],
            }
        },
        mounted() {
            this.fetchDirectories();
            this.getSelected();
        },
        methods: {
            fetchDirectories() {
                this.loading = true;
                axios.get('/mediaserver/directory').then((response) => {
                    this.tree = response.data;
                    this.loading = false;
                });
            },
            getSelected() {
                let parameters = this.$parent.filter;
                this.selected.push(JSON.stringify({index: parameters.index, directory: parameters.directory || ''}));
            },
        },
        watch: {
            loading() {
                this.$nextTick(() => {
                    $('#jstree').jstree({
                        'core': {
                            'themes': {
                                'name': 'proton',
                                'responsive': true
                            },
                            'multiple': false,
                            'check_callback': true
                        }
                    });
                    $('#jstree').on("changed.jstree", function (e, data) {
                        if (data.node) {
                            this.uri.removeQuery('page');

                            _.forEach(JSON.parse(data.node.id), (value, key) => {
                                this.uri.removeQuery(key);

                                if (value) {
                                    this.uri.addQuery(key, value);
                                }
                            });

                            window.location.href = this.uri.toString();
                        }
                    }.bind(this));
                });
            },
        }
    }
</script>

<template>
    <div>
        <div v-if="loading" class="text-center p-m">
            <span>Loading</span>
            <i class="fa fa-cog fa-spin"></i>
        </div>
        <div v-else>
            <media-directory-actions
                    :tree="tree"
                    :selected="selected"
                    v-if="seeDirectoryActions"
            ></media-directory-actions>

            <div id="jstree">
                <ul>
                    <tree-node
                            class="jstree-open"
                            :node="tree"
                            :children-collapsed="true"
                            :selected="selected"
                            key="directory-root"
                    ></tree-node>
                </ul>
            </div>
        </div>
    </div>
</template>
